'use client'

import type { NotFoundProps } from '@maestro/commerce-blocks/components/not-found/not-found.types'

import { useTranslations } from 'next-intl'
import NextImage from 'next/image'
import { useEffect } from 'react'

import { TrackingButton } from '@maestro/commerce-blocks/components/tracking-button'
import { useScrollToHeader } from '@maestro/commerce-blocks/hooks/use-scroll-to-header'
import { useA11y } from '@maestro/core/a11y/a11y.context'

import '@maestro/commerce-blocks/components/not-found/styles/not-found.scss'

export default function NotFound(props: NotFoundProps) {
  useScrollToHeader(true)
  const { cmsBlock, children } = props
  const t = useTranslations('commerce-blocks')
  const { announce } = useA11y()

  useEffect(() => {
    announce(t('not-found.announcement'))
  }, [announce, t])

  return (
    <>
      <div className="not-found" data-testid="not-found-page">
        <div className="not-found__cms">
          {cmsBlock ? (
            cmsBlock
          ) : (
            <>
              <NextImage
                className="not-found__icon"
                src="/assets/icons/icon-no-results.svg"
                width={220}
                height={162}
                alt="" // empty alt to hide image from screen readers
                role="presentation"
                loading="lazy"
              />
              <div className="not-found__description">
                <h1 className="not-found__title">{t('not-found.title')}</h1>
                <p className="not-found__text">{t('not-found.description')}</p>
              </div>
              <TrackingButton
                location="Not found"
                type="primary"
                className="not-found__button"
                url="/"
              >
                {t('not-found.action')}
              </TrackingButton>
            </>
          )}
        </div>
        {children}
      </div>
    </>
  )
}
